import React, { useEffect, useState } from "react"
import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom"
import axios from "axios"
import SidebarCircuito from "./SidebarCircuito"
import { FaBars, FaSignOutAlt, FaShieldAlt, FaSpinner } from "react-icons/fa"
import "../../styles/circuitoDesignSystem.css"
import "../../styles/painelCircuito.css"

const customDomains = {
  "campeonatoportinha.com": "portinha",
  "www.campeonatoportinha.com": "portinha",
  "circuitosertao.com": "sertao",
  "www.circuitosertao.com": "sertao",
};

// 💡 AQUI FOI CORRIGIDO: Adicionado o { customSlug } para receber o dado do App.js
export default function LayoutPainelCircuito({ customSlug }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [circuito, setCircuito] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  // 🛡️ Estados de Segurança
  const [authCheckComplete, setAuthCheckComplete] = useState(false);
  const [podeAcessar, setPodeAcessar] = useState(false);

  const hostname = window.location.hostname;
  const domainSlug = customDomains[hostname];

  // 💡 A MÁGICA AQUI: Se veio o customSlug (do domínio próprio), usa ele. Se não, usa o da URL (params.slug).
  const slug = customSlug || params.slug;
  const basePath = domainSlug ? "/painel" : `/painel-circuito/${slug}`;
  const siteBaseUrl = domainSlug ? "" : `/circuito/${slug}`;
  const isLoginPage = location.pathname.endsWith('/login');

  useEffect(() => {
    const carregarCircuito = async () => {
      try {
        const res = await axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/slug/${slug}`);
        setCircuito(res.data?.circuito || null);
      } catch (err) {
        navigate("/");
      } finally {
        setLoading(false);
      }
    };
    if (slug) carregarCircuito();
  }, [slug, navigate]);

  useEffect(() => {
    if (circuito) {
      document.title = `Painel - ${circuito.nome}`;
      if (circuito.imagem) {
        const faviconUrl = `https://api.ticketdovaqueiro.com/uploads/${circuito.imagem}`;
        let link = document.querySelector("link[rel~='icon']");
        if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
        link.href = faviconUrl;
      }
    }
  }, [circuito]);

  // =========================================================================
  // 🛡️ A BARREIRA INQUEBRÁVEL - Avalia antes de renderizar qualquer coisa
  // =========================================================================
  useEffect(() => {
    if (loading || !circuito) return; // Aguarda os dados base chegarem

    const token = localStorage.getItem("token");
    let storedUser = null;
    try { storedUser = JSON.parse(localStorage.getItem("user")); } catch(e){}

    const isAuth = !!(token && token !== "null" && token !== "undefined" && storedUser);
    
    let temPermissao = false;
    if (isAuth) {
        if (storedUser.tipo === "admin") temPermissao = true;
        else if (storedUser.tipo === "gerente_circuito" && storedUser.circuitoId === circuito._id) temPermissao = true;
    }

    setPodeAcessar(temPermissao);
    setAuthCheckComplete(true);

    // Se não for a página de login e não tiver permissão, redireciona ativamente!
    if (!isLoginPage && !temPermissao) {
        if (!isAuth) {
            navigate(`${basePath}/login`, { replace: true });
        }
    }
  }, [location.pathname, loading, circuito, navigate, basePath, isLoginPage]);

  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  // Telas de Carregamento e Erro
  if (loading || !authCheckComplete) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--c-bg, #0f0f0f)', color: 'var(--c-accent, #d4af37)' }}>
            <FaSpinner className="fa-spin" size={40} />
        </div>
      );
  }
  
  if (!circuito) return <div className="pc-layout"><div className="pc-empty">Circuito não encontrado.</div></div>;

  // 1. Se estiver na rota de Login, libera o formulário
  if (isLoginPage) {
      return <Outlet context={{ circuito, slugAtivo: slug }} />;
  }

  // 2. Se tentou acessar o painel e NÃO TEM PERMISSÃO (barrado na porta)
  if (!podeAcessar) {
      return (
          <div style={{ height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "var(--c-bg, #0f0f0f)", color: "#fff", textAlign: "center", padding: 20 }}>
            <FaShieldAlt size={60} color="#ef4444" style={{ marginBottom: 20 }} />
            <h2 style={{color: "#fff", fontSize: 28, marginBottom: 10}}>Acesso Restrito</h2>
            <p style={{marginBottom: 30, color: "rgba(255,255,255,0.6)"}}>Sua conta não possui privilégios para acessar este painel.</p>
            <button 
              onClick={() => { localStorage.removeItem("token"); localStorage.removeItem("user"); window.location.href = `${basePath}/login`; }} 
              className="c-btn c-btn--primary" 
              style={{display: "flex", gap: 10, alignItems: "center", height: 48, padding: "0 24px", fontSize: 16, fontWeight: "bold"}}
            >
              <FaSignOutAlt /> Sair e Fazer Login
            </button>
          </div>
      );
  }

  // 3. Se tem permissão, renderiza o Painel Lindo!
  return (
    <div className="pc-layout painel-circuito-layout">
      <div className={`pc-sidebar-overlay ${sidebarOpen ? "pc-sidebar-overlay--open" : ""}`} onClick={() => setSidebarOpen(false)} />

      <SidebarCircuito
        circuito={circuito}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        basePath={basePath}
        siteBaseUrl={siteBaseUrl}
      />

      <div className="pc-main">
        <div className="pc-topbar">
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <button className="pc-mobile-toggle" onClick={() => setSidebarOpen(true)}><FaBars /></button>
            <span className="pc-topbar__title">Painel {circuito?.nome}</span>
          </div>
        </div>

        <div className="pc-content">
          <Outlet context={{ circuito, slugAtivo: slug }} />
        </div>
      </div>
    </div>
  )
}